// extracted by mini-css-extract-plugin
export default {"errorMessage":"app_errorMessage__0CHx5"};